export enum EReportFormat {
  CSV = 'csv',
  XLS = 'xls',
  JSON = 'json',
  PDF = 'pdf',
}

export enum EReportLabel {
  EXPORT_TO_PDF = 'Export to PDF',
  EXPORT_TO_CSV = 'Export to CSV',
  EXPORT_TO_JSON = 'Export to JSON',
  EXPORT_DATA = 'Export Data',
}
export const QUERY_PARAMS_KEYS = [
  'order',
  'orderBy',
  'page',
  'limit',
  'inactive',
  'includeInactive',
];
